import { interruptFiber, interruptAsFiber } from '../../internal/core.esm.js';
import { zipFiber, zipLeftFiber, zipRightFiber, zipWithFiber } from '../../internal/effect/circular.esm.js';
import { FiberTypeId as FiberTypeId$1, RuntimeFiberTypeId as RuntimeFiberTypeId$1, Order as Order$1, isFiber as isFiber$1, isRuntimeFiber as isRuntimeFiber$1, id as id$1, _await as _await$1, children as children$1, done as done$1, dump as dump$1, dumpAll as dumpAll$1, fail as fail$1, failCause as failCause$1, fromEffect as fromEffect$1, getCurrentFiber as getCurrentFiber$1, inheritAll as inheritAll$1, interrupted as interrupted$1, interruptAsFork as interruptAsFork$1, interruptAll as interruptAll$1, interruptAllAs as interruptAllAs$1, join as join$1, map as map$1, mapEffect as mapEffect$1, mapFiber as mapFiber$1, match as match$1, never as never$1, orElse as orElse$1, orElseEither as orElseEither$1, poll as poll$1, pretty as pretty$1, roots as roots$1, unsafeRoots as unsafeRoots$1, status as status$1, succeed as succeed$1, unit as unit$1 } from '../../internal/fiber.esm.js';
import { fiberAwaitAll, fiberAll, fiberInterruptFork, fiberJoinAll, fiberScoped } from '../../internal/fiberRuntime.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const FiberTypeId = FiberTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const RuntimeFiberTypeId = RuntimeFiberTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A fiber is a lightweight thread of execution that never consumes more than a
 * whole thread (but may consume much less, depending on contention and
 * asynchronicity). Fibers are spawned by forking effects, which run
 * concurrently with the parent effect.
 *
 * Fibers can be joined, yielding their result to other fibers, or interrupted,
 * which terminates the fiber, safely releasing all resources.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * A runtime fiber that is executing an effect. Runtime fibers have an
 * identity and a trace.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category instances
 */
const Order = Order$1;

/**
 * Returns `true` if the specified value is a `Fiber`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isFiber = isFiber$1;

/**
 * Returns `true` if the specified `Fiber` is a `RuntimeFiber`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRuntimeFiber = isRuntimeFiber$1;

/**
 * The identity of the fiber.
 *
 * @since 2.0.0
 * @category getters
 */
const id = id$1;
const _await = _await$1;

/**
 * Awaits on all fibers to be completed, successfully or not.
 *
 * @since 2.0.0
 * @category destructors
 */
const awaitAll = fiberAwaitAll;

/**
 * Retrieves the immediate children of the fiber.
 *
 * @since 2.0.0
 * @category getters
 */
const children = children$1;

/**
 * Collects all fibers into a single fiber producing an in-order list of the
 * results.
 *
 * @since 2.0.0
 * @category constructors
 */
const all = fiberAll;

/**
 * A fiber that is done with the specified `Exit` value.
 *
 * @since 2.0.0
 * @category constructors
 */
const done = done$1;

/**
 * @since 2.0.0
 * @category destructors
 */
const dump = dump$1;

/**
 * @since 2.0.0
 * @category destructors
 */
const dumpAll = dumpAll$1;

/**
 * A fiber that has already failed with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail = fail$1;

/**
 * Creates a `Fiber` that has already failed with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCause = failCause$1;

/**
 * Lifts an `Effect` into a `Fiber`.
 *
 * @since 2.0.0
 * @category conversions
 */
const fromEffect = fromEffect$1;

/**
 * Gets the current fiber if one is running.
 *
 * @since 2.0.0
 * @category utilities
 */
const getCurrentFiber = getCurrentFiber$1;

/**
 * Inherits values from all `FiberRef` instances into current fiber. This
 * will resume immediately.
 *
 * @since 2.0.0
 * @category destructors
 */
const inheritAll = inheritAll$1;

/**
 * Interrupts the fiber from whichever fiber is calling this method. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interrupt = interruptFiber;

/**
 * Constructrs a `Fiber` that is already interrupted.
 *
 * @since 2.0.0
 * @category constructors
 */
const interrupted = interrupted$1;

/**
 * Interrupts the fiber as if interrupted from the specified fiber. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAs = interruptAsFiber;

/**
 * Interrupts the fiber as if interrupted from the specified fiber. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAsFork = interruptAsFork$1;

/**
 * Interrupts all fibers, awaiting their interruption.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAll = interruptAll$1;

/**
 * Interrupts all fibers as by the specified fiber, awaiting their
 * interruption.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAllAs = interruptAllAs$1;

/**
 * Interrupts the fiber from whichever fiber is calling this method. The
 * interruption will happen in a separate daemon fiber, and the returned
 * effect will always resume immediately without waiting.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptFork = fiberInterruptFork;

/**
 * Joins the fiber, which suspends the joining fiber until the result of the
 * fiber has been determined. Attempting to join a fiber that has erred will
 * result in a catchable error. Joining an interrupted fiber will result in an
 * "inner interruption" of this fiber, unlike interruption triggered by
 * another fiber, "inner interruption" can be caught and recovered.
 *
 * @since 2.0.0
 * @category destructors
 */
const join = join$1;

/**
 * Joins all fibers, awaiting their _successful_ completion. Attempting to
 * join a fiber that has erred will result in a catchable error, _if_ that
 * error does not result from interruption.
 *
 * @since 2.0.0
 * @category destructors
 */
const joinAll = fiberJoinAll;

/**
 * Maps over the value the Fiber computes.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = map$1;

/**
 * Effectually maps over the value the fiber computes.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapEffect = mapEffect$1;

/**
 * Passes the success of this fiber to the specified callback, and continues
 * with the fiber that it returns.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapFiber = mapFiber$1;

/**
 * Folds over the `Fiber` or `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

/**
 * A fiber that never fails or succeeds.
 *
 * @since 2.0.0
 * @category constructors
 */
const never = never$1;

/**
 * Returns a fiber that prefers `this` fiber, but falls back to the `that` one
 * when `this` one fails. Interrupting the returned fiber will interrupt both
 * fibers, sequentially, from left to right.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElse = orElse$1;

/**
 * Returns a fiber that prefers `this` fiber, but falls back to the `that` one
 * when `this` one fails. Interrupting the returned fiber will interrupt both
 * fibers, sequentially, from left to right.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElseEither = orElseEither$1;

/**
 * Tentatively observes the fiber, but returns immediately if it is not
 * already done.
 *
 * @since 2.0.0
 * @category getters
 */
const poll = poll$1;

/**
 * Pretty-prints a `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category destructors
 */
const pretty = pretty$1;

/**
 * Returns a chunk containing all root fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
const roots = roots$1;

/**
 * Returns a chunk containing all root fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
const unsafeRoots = unsafeRoots$1;

/**
 * Converts this fiber into a scoped effect. The fiber is interrupted when the
 * scope is closed.
 *
 * @since 2.0.0
 * @category destructors
 */
const scoped = fiberScoped;

/**
 * Returns the `FiberStatus` of a `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category getters
 */
const status = status$1;

/**
 * Returns a fiber that has already succeeded with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeed = succeed$1;

/**
 * A fiber that has already succeeded with unit.
 *
 * @since 2.0.0
 * @category constructors
 */
const unit = unit$1;

/**
 * Zips this fiber and the specified fiber together, producing a tuple of
 * their output.
 *
 * @since 2.0.0
 * @category zipping
 */
const zip = zipFiber;

/**
 * Same as `zip` but discards the output of that `Fiber`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipLeft = zipLeftFiber;

/**
 * Same as `zip` but discards the output of this `Fiber`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipRight = zipRightFiber;

/**
 * Zips this fiber with the specified fiber, combining their results using the
 * specified combiner function. Both joins and interruptions are performed in
 * sequential order from left to right.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipWith = zipWithFiber;

export { FiberTypeId, Order, RuntimeFiberTypeId, all, _await as await, awaitAll, children, done, dump, dumpAll, fail, failCause, fromEffect, getCurrentFiber, id, inheritAll, interrupt, interruptAll, interruptAllAs, interruptAs, interruptAsFork, interruptFork, interrupted, isFiber, isRuntimeFiber, join, joinAll, map, mapEffect, mapFiber, match, never, orElse, orElseEither, poll, pretty, roots, scoped, status, succeed, unit, unsafeRoots, zip, zipLeft, zipRight, zipWith };
